<template>
  <div>
    <list-view></list-view>
  </div>
</template>

<script>
export default {
  components: {
    ListView: () => import('../../components/Parcel/ListView.vue')
  },
  mounted() {
    this.$store.commit('viewMode', 'list');
  }
};
</script>

<style>
</style>
